import { useAuth } from "~/context/AuthContext";
import AgencyLayout from "~/views/layout/AgencyLayout";
import AppLayout from "~/views/layout/AppLayout";

export default function AccountLayout() {
  const { user } = useAuth();
  if (user?.agency) {
    return <AgencyLayout />;
  }
  return <AppLayout />;
}
